/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/SessionsPageQuery$parameters';
import type { Queries } from './SessionsPage.types.tsx';

type BusinessSessionsEntrypointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const businessSessionsEntrypoint: EntryPoint<
	BusinessSessionsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<BusinessSessionsEntrypointComponent>(
		/* webpackChunkName: "async-business-sessions-entrypoint" */ './SessionsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
		tenantContext: { cloudId },
	}: EntryPointRouteParams) => ({
		queries: {
			sessions: {
				options: { fetchPolicy: 'store-or-network' as const },
				parameters,
				variables: { cloudId, scope: { spaceKey: String(params.projectKey) } },
			},
		},
	}),
});
